import React from "react";
import ListIcon from "@mui/icons-material/List";
import SettingsIcon from "@mui/icons-material/Settings";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

const menuItems = [
  {
    icon: <DashboardIcon />,
    text: "NavBar.Dashboard",
    path: "/dashboard",
    name: "Dashboard",
    roles: ["Administrator", "Customer"]
  },
  {
    icon: <ListIcon />,
    text: "NavBar.Partners",
    path: "/partners",
    name: "Partners",
    roles: ["Administrator", "Customer"]
  },
  {
    icon: <ListIcon />,
    text: "NavBar.SelfPartner",
    path: "/selfPartner",
    name: "SelfPartner",
    roles: ["Administrator", "Customer"]
  },
  {
    icon: <ListIcon />,
    text: "NavBar.Banks",
    path: "/banks",
    name: "Banks",
    roles: ["Administrator", "Customer"]
  },
  {
    icon: <ListIcon />,
    text: "NavBar.PartnerHierarchies",
    path: "/partnerHierarchies",
    name: "PartnerHierarchies",
    roles: ["Administrator", "Customer"]
  },
  {
    icon: <SettingsIcon />,
    text: "NavBar.Settings",
    path: "/settings",
    name: "Settings",
    roles: ["Administrator", "Customer"]
  },
  { icon: <ReportProblemIcon />, text: "NavBar.Logs", path: "/logs", name: "Logs", roles: ["Administrator"] }
];

export default menuItems;
